module.exports = __webpack_public_path__ + "static/img/pregunta-tus-datos.07c8c3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pregunta-tus-datos.png
// module id = D01m
// module chunks = 3